import { render, staticRenderFns } from "./SMMortgageRequests.vue?vue&type=template&id=1043554f&"
import script from "./SMMortgageRequests.vue?vue&type=script&lang=js&"
export * from "./SMMortgageRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports